<div class="global-progress-bar-container"><mat-progress-bar mode="indeterminate" [style.visibility]="globalLoadingVisibility$ | async"></mat-progress-bar></div>
<app-progress-spinner></app-progress-spinner>
<app-dashboard-header *ngIf="!isLogin && (isShopifyPage$ | async) === false"></app-dashboard-header>
<router-outlet></router-outlet>
